import { render, staticRenderFns } from "./IconGraph.vue?vue&type=template&id=0604f3d6"
import script from "./IconGraph.vue?vue&type=script&lang=js"
export * from "./IconGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports